import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import {
    Box,
    Card,
    CardActionArea,
    CardContent,
    CardHeader,
    List,
    ListItemButton,
    ListItemText,
    Typography,
    Tooltip,
} from "@mui/material";
import AlertMessage from "../../../Common/Alert/AlertMessage";
import MSFAvatar from "../MSFAvatar";

import { displayFullName } from "../../../../utilities/formatters";

import msfActions from "../../../../actions/msfActions";
import { getQuestionnaires } from "../../../../reducers";

const QuestionnaireCard = () => {
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(msfActions.getQuestionnaires("P-MSF"));
    }, [dispatch]);

    const questionnaires = useSelector(getQuestionnaires);
    const totalCount = questionnaires?.length || 0;

    return (
        <Card className="card">
            <CardActionArea
                component={Link}
                to="/msf/questionnaires/"
                centerRipple
            >
                <CardHeader
                    disableTypography
                    avatar={
                        <Tooltip title="View all questionnaires" arrow>
                            <MSFAvatar type="questionnaire" />
                        </Tooltip>
                    }
                    title={
                        <Typography
                            component="h2"
                            className="card-header-title"
                        >
                            Questionnaires
                        </Typography>
                    }
                    subheader={
                        <Typography
                            component="span"
                            className="card-header-subtitle"
                        >
                            {`${totalCount} questionnaire${
                                totalCount !== 1 ? "s" : ""
                            }`}
                        </Typography>
                    }
                />
            </CardActionArea>
            {totalCount > 0 ? (
                <CardContent>
                    <List
                        sx={{
                            width: "100%",
                            height: "350px",
                            overflow: "auto",
                        }}
                    >
                        {questionnaires.map(
                            ({ uuid, title, type, requester }) => (
                                <ListItemButton
                                    alignItems="flex-start"
                                    key={uuid}
                                    component="div"
                                >
                                    <Link to={`/msf/questionnaires/${uuid}`}>
                                        <ListItemText
                                            disableTypography={true}
                                            primary={
                                                <Typography
                                                    component="h3"
                                                    className="list-item-primary"
                                                >
                                                    {title !== null &&
                                                    title !== ""
                                                        ? title
                                                        : type?.name}
                                                </Typography>
                                            }
                                            secondary={
                                                <Typography component="span">
                                                    {displayFullName(
                                                        requester
                                                    ) || "Unknown"}
                                                </Typography>
                                            }
                                        />
                                    </Link>
                                </ListItemButton>
                            )
                        )}
                    </List>
                </CardContent>
            ) : (
                <CardContent>
                    <Box className="card-content">
                        <AlertMessage
                            severity="info"
                            message="no questionnaires found"
                        />
                    </Box>
                </CardContent>
            )}
        </Card>
    );
};

export default QuestionnaireCard;
